import { useState, useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Terminal as TerminalIcon, X } from 'lucide-react';

const terminalLines = [
  "Initialize Emilia_Core_v2.4.1",
  "Bypassing conventional IG rate-limits... [BYPASSED]",
  "Establishing secure link to Neuralworks nodes... [OK]",
  "Loading visual matrices and aesthetic rulesets... 100%",
  "Loading synthetic voice models... 100%",
  "Entity 'Emilia_Ivanova' is actively processing.",
  "Warning: Subject possesses high autonomy parameters.",
  "Awaiting external override commands..."
];

export function TerminalButton() {
  const [isOpen, setIsOpen] = useState(false);
  const [displayedLines, setDisplayedLines] = useState<string[]>([]);
  const bottomRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!isOpen) return;
    let currentLine = 0;
    setDisplayedLines([]);

    const interval = setInterval(() => {
      if (currentLine < terminalLines.length) {
        setDisplayedLines(prev => [...prev, terminalLines[currentLine]]);
        currentLine++;
      } else {
        clearInterval(interval);
      }
    }, 400);

    return () => clearInterval(interval);
  }, [isOpen]);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [displayedLines]);

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-6 left-6 z-50 p-3 bg-white/5 border border-white/10 rounded backdrop-blur-md hover:bg-white/10 hover:border-brand transition-all group md:cursor-none"
        title="Terminal Protocol"
      >
        <TerminalIcon size={16} className="text-white/30 group-hover:text-brand transition-colors" />
      </button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: 50, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            className="fixed bottom-24 left-6 z-50 w-[90vw] max-w-sm h-64 bg-black/95 border border-green-500/30 rounded shadow-2xl font-mono text-xs text-green-500 overflow-hidden flex flex-col backdrop-blur-xl"
          >
            <div className="flex justify-between items-center px-4 py-2 border-b border-green-500/30 bg-green-500/10">
              <span className="tracking-widest">sys.term</span>
              <button onClick={() => setIsOpen(false)} className="hover:text-white transition-colors p-1 md:cursor-none"><X size={14} /></button>
            </div>
            <div className="p-4 overflow-y-auto flex-1">
              {displayedLines.map((line, i) => (
                <div key={i} className="mb-2">{"> "}{line}</div>
              ))}
              {displayedLines.length === terminalLines.length && (
                <motion.div
                  animate={{ opacity: [0, 1] }}
                  transition={{ repeat: Infinity, duration: 0.8 }}
                  className="w-2 h-4 bg-green-500 inline-block align-middle ml-1"
                />
              )}
              <div ref={bottomRef} className="h-1" />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}

